import React, { Component } from 'react';
import "./ColorpickerPointer.scss";

export var ColorpickerPointerCircle = function ColorpickerPointerCircle() {

  return React.createElement("div", { className: "admin-colorpicker__pointer  pointer--circle" });
};

export default ColorpickerPointerCircle;